import Vue from 'vue'
import Router from 'vue-router'
import MyStudentsPage from '@/components/student/MyStudentsPage'
import LoginPage from '@/components/login/LoginPage'
import LoginSSO from '@/components/login/LoginSSO'
import DashboardPage from '@/components/dashboard/DashboardPage'
import StudentPage from '@/components/student/StudentPage'
import InteractionsPage from '@/components/intervention/InteractionsPage'
import AlertDetails from '@/components/settings/alert/AlertDetails'
import AlertsLanding from '@/components/settings/alert/AlertsLanding'
import AdminPage from '@/components/settings/AdminPage'
import DailyFeedsPage from '@/components/monitor/DailyFeedsPage'
import FeedRequestBreakdownInfo from '@/components/monitor/FeedRequestBreakdownInfo'
import InsightsPage from '@/components/insights/InsightsPage'
import HelpPage from '@/components/help/HelpPage'
import SupportPage from '@/components/help/SupportPage'
import AnnouncementEditPage from '@/components/announcement/edit/AnnouncementEditPage'
import ErrorPage from '@/components/ErrorPage'
import store from '../store'
import server from '../store/server'
import { SET_PREVIOUS_ROUTE } from '../store/mutation-types'
import { GET_ENGAGEMENT_LAST_SUCCESSFUL } from '../store/action-types'

Vue.use(Router)

const shouldntBeLoggedIn = function (to, from, next) {
  if (store.state.profile.loggedIn) {
    next(store.getters.IS_STUDENT ? '/student' : '/dashboard')
  } else if (store.state.config.useSSO || store.state.config.useSAML) {
    window.stop()
    server.removeAuthOnPage()
    window.location.replace(store.state.config.authUrlLogOut)
  } else {
    next()
  }
}

const isLoggedOn = function (next) {
  if (store.state.config.useSSO && !store.state.profile.loggedIn) {
    window.location.replace(store.state.config.authUrl)
    return false
  } else if (!store.state.profile.loggedIn) {
    next('/login')
    return false
  }
  return true
}

const studentCheck = function (next, isStudent, redirect) {
  if (isLoggedOn(next)) {
    if (store.getters.IS_STUDENT === isStudent) {
      next()
    } else {
      next(redirect)
    }
  }
}

/* const notAStudent = function (to, from, next) {
  studentCheck(next, false, '/student')
} */

const onlyAStudent = function (to, from, next) {
  studentCheck(next, true, '/dashboard')
}

const adminOrStaff = function (to, from, next) {
  if (isLoggedOn(next)) {
    if (store.getters.IS_ADMIN || store.getters.IS_STAFF) {
      next()
    } else {
      next('/student')
    }
  }
}

const adminOrStaffAndInteractionAccess = function (to, from, next) {
  let flagEnableInteractions = store.getters.HAS_FEATURE_FLAG(store.state.profile.module.interexem + '.' + store.state.profile.functions.headerMenu + '.' + store.state.profile.options.enable.interactions)
  if (isLoggedOn(next)) {
    if (store.getters.IS_ADMIN || store.getters.IS_STAFF) {
      if (flagEnableInteractions) {
        next()
      } else {
        next('/dashboard')
      }
    } else {
      next('/student')
    }
  }
}

const onlyAdmin = function (to, from, next) {
  if (isLoggedOn(next)) {
    if (store.getters.IS_ADMIN) {
      next()
    } else {
      next(store.getters.IS_STUDENT ? '/student' : '/dashboard')
    }
  }
}

const onlyAdminAndAlertAccess = function (to, from, next) {
  let flagEnableAlerts = store.getters.HAS_FEATURE_FLAG(store.state.profile.module.alert + '.' + store.state.profile.functions.adminMenu + '.' + store.state.profile.options.enable.alerts)
  if (isLoggedOn(next)) {
    if (store.getters.IS_ADMIN && flagEnableAlerts) {
      next()
    } else {
      next(store.getters.IS_STUDENT ? '/student' : '/dashboard')
    }
  }
}
const initialPage = function (to, from, next) {
  if (isLoggedOn(next)) {
    next(store.getters.IS_STUDENT ? '/student' : '/dashboard')
  }
}

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      beforeEnter: shouldntBeLoggedIn
    },
    {
      path: '/loginsso',
      name: 'LoginSSO',
      component: LoginSSO
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/students',
      name: 'Students',
      component: MyStudentsPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/interactions',
      name: 'Interactions',
      component: InteractionsPage,
      beforeEnter: adminOrStaffAndInteractionAccess
    },
    {
      path: '/student/:id',
      name: 'Student',
      component: StudentPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/student/:id/intervention/:intervention_id',
      name: 'TutorIntervention',
      component: StudentPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/student/:id/interactions',
      name: 'TutorInteractions',
      component: StudentPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/student/:id/attendance',
      name: 'TutorAttendance',
      component: StudentPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/student',
      name: 'StudentHome',
      component: StudentPage,
      beforeEnter: onlyAStudent
    },
    {
      path: '/student/:id/exemption/:exemption_id',
      name: 'TutorExemption',
      component: StudentPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/student/:id/exemption/:alert_id',
      name: 'TutorAlert',
      component: StudentPage,
      beforeEnter: adminOrStaff
    },
    {
      path: '/admin',
      name: 'Admin',
      component: AdminPage,
      beforeEnter: onlyAdmin
    },
    {
      path: '/admin/alerts',
      name: 'AdminAlerts',
      component: AlertsLanding,
      beforeEnter: onlyAdminAndAlertAccess
    },
    {
      path: '/admin/alert/:id',
      name: 'AlertDetails',
      component: AlertDetails,
      beforeEnter: onlyAdminAndAlertAccess
    },
    {
      path: '/admin/dailyfeeds',
      name: 'DailyFeeds',
      component: DailyFeedsPage,
      beforeEnter: onlyAdmin
    },
    {
      path: '/admin/feedbreakdowninfo/:id',
      name: 'FeedRequestBreakdownInfo',
      component: FeedRequestBreakdownInfo,
      beforeEnter: onlyAdmin
    },
    {
      path: '/admin/announcements',
      name: 'AdminAnnouncements',
      component: AnnouncementEditPage,
      beforeEnter: onlyAdmin
    },
    {
      path: '/insights',
      name: 'Insights',
      component: InsightsPage,
      beforeEnter: onlyAdmin
    },
    {
      path: '/help',
      name: 'Help',
      component: HelpPage // No security
    },
    {
      path: '/support/:id',
      name: 'Support',
      component: SupportPage // No security
    },
    {
      path: '*',
      beforeEnter: initialPage
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorPage
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.commit(SET_PREVIOUS_ROUTE, from)
  store.dispatch(GET_ENGAGEMENT_LAST_SUCCESSFUL)
  if (store.state.config.pageTitle !== undefined && store.state.config.pageTitle !== '') {
    document.title = store.state.config.pageTitle
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js